import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { type RootState } from '@editor2/reducers/root';

import { activeChangesBlock } from './styles';
import ChapterChanges from './ChapterChanges';
import PageGroupChanges from './PageGroupChanges';
import TocChanges from './TocChanges';
import PageChanges from './PageChanges';
import ElementsChanges from './ElementsChanges';
import { checkLectureSlideDecksOrderChanged } from '@editor2/services/unsavedChangesService';

interface Props {
	courseId: number;
	style?: string;
}

const ActiveChanges: FC<Props> = (props) => {
	const { courseId, style = activeChangesBlock } = props;

	const { changes } = useSelector((state: RootState) => state.courses[courseId]);

	return (
		<div className={style}>
			{(!!changes.toc.length ||
				!!changes.resourceConfig.length ||
				checkLectureSlideDecksOrderChanged(changes)) && <TocChanges courseId={courseId} />}

			{Object.keys(changes.chapters).map(
				(chapterId) =>
					!!changes.chapters[chapterId].length && (
						<ChapterChanges chapterId={chapterId} courseId={courseId} key={chapterId} />
					)
			)}

			{Object.keys(changes.page_groups).map(
				(pageGroupId) =>
					!!changes.page_groups[pageGroupId].length && (
						<PageGroupChanges pageGroupId={pageGroupId} courseId={courseId} key={pageGroupId} />
					)
			)}

			{Object.keys(changes.pages).map(
				(pageId) =>
					!!changes.pages[pageId].length && (
						<PageChanges pageId={pageId} courseId={courseId} key={pageId} />
					)
			)}

			{Object.keys(changes.elements).map(
				(elementId) =>
					!!changes.elements[elementId].length && (
						<ElementsChanges elementId={elementId} courseId={courseId} key={elementId} />
					)
			)}
		</div>
	);
};

export default ActiveChanges;
